// 招商审核
import store from '@/store';
import {agentLevelList,statusList} from '@/util/dictList'
export const option = {
  height: 'auto',
  calcHeight: 80,
  tip: false,
  delBtn: false,
  editBtn: false,
  addBtnText: '新增招商码',
  addTitle: '新增招商码',
  addBtn: false,
  searchShow: true,
  searchMenuSpan: 6,
  searchSpan:6,
  searchLabelWidth: 100,
  border: true,
  index: false,
  menu: true,
  indexLabel: '序号',
  selection: false,
  viewBtn: false,
  dialogType: 'dialog',
  dialogClickModal: false,
  column: [
    {
      label: '代理商简称',
      prop: 'agentShortName',
      type: 'input',
      search:true,
      searchOrder: 1000,
      minWidth:120,
    },
    {
      label: '负责人',
      prop: 'principalName',
      type: 'input',
      // formatter: (row, value) => {
      //   if (row?.legalPersonAsPrincipal) {
      //     return row?.legalPersonName??'/'
      //   }
      //   return value??'/'
      // }
    },
    {
      label: '手机号码',
      prop: 'principalMobile',
      type: 'input',
      search:true,
      searchOrder: 999,
      // formatter: (row, value) => {
      //   if (row?.legalPersonAsPrincipal) {
      //     return row?.legalPersonMobile??'/'
      //   }
      //   return value??'/'
      // }
    },
    {
      label: '招商经理',
      prop: 'managerCode',
      type: 'select',
      searchOrder: 997,
      search:true,
      hide: true,
      dicUrl: '/api/blade-loanManagerCodeInfo/loanManagerCodeInfo/dropDown',
      props: {
        label: 'managerName',
        value: 'managerCode'
      }
    },

  ],
};
// 公共部分
export const publicColumn = [
  {
    label: '开通城市',
    prop: 'cityOpened',
    type: 'input',
    display:false
  },
  {
    label: '开通产品',
    prop: 'rentType',
    type: 'select',
    display:false,
    search:true,
    searchOrder: 998,
    dicData: store.getters.porductTypes,
  },
  {
    label: '申请日期',
    prop: 'createTime',
    type: 'input',
    display:false
  },
  {
    label: '招商经理',
    prop: 'managerName',
    type: 'input',
    display:false
  }
]

// 处理中
export const disposeColumn =[{
    label: '代理级别',
    prop: 'agentLevel',
    type: 'select',
    display:false,
    dicData: agentLevelList,
  },
  ...publicColumn,
  {
    label: '节点',
    prop: 'auditNode',
    slot: true,
    type: 'input',
    minWidth:150,
    display:false
  },
]

// 已处理
export const processedColumn =[
  ...publicColumn,
  {
    label: '状态',
    prop: 'auditStatus',
    type: 'select',
    display:false,
    dicData: statusList,
  }
]
